import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { ChevronDown, ChevronUp } from "../Icons";

function NavigationItem({
  children,
  className = "",
  id,
  onClick,
  show,
  text,
}) {
  const itemId = id.toLowerCase().replace(/\s+/g, "-");

  return (
    <li>
      <button
        className={classNames(
          "btn",
          className,
          show ? "" : "collapsed"
        )}
        type="button"
        data-bs-toggle="collapse"
        data-bs-target={`${itemId}-navigation-item`}
        aria-expanded={show.toString()}
        aria-controls={id}
        onClick={onClick}
      >
        {text}
        <FontAwesomeIcon
          icon={show ? ChevronUp : ChevronDown}
          size="sm"
        />
      </button>
      <div
        className={classNames("collapse", show ? "show" : "")}
        id={`${itemId}-navigation-item`}
      >
        <ul className="nav flex-column">{children}</ul>
      </div>
    </li>
  );
}

export default NavigationItem;
